import { render, staticRenderFns } from "./TopSectionSettings.vue?vue&type=template&id=70724723&"
import script from "./TopSectionSettings.vue?vue&type=script&lang=js&"
export * from "./TopSectionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports